// helpers/rutaLotes.js
import axios from "axios";

// Base tomada del .env o fallback a producción
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");     // quita / al final
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- LOTES ----

// GET: lista
export const getLotes = async () => {
  const { data } = await API.get(p("lotes"), auth());
  // normalmente el back responde { ok, lotes, cantidad }
  return data;
};

// GET: una por id
export const getLoteById = async (id) => {
  const { data } = await API.get(p(`lotes/${id}`), auth());
  return data;
};

// POST: crear
export const postLote = async (payload) => {
  const { data } = await API.post(p("lotes"), payload, auth());
  return data;
};

// PUT: actualizar
export const putLote = async (id, payload) => {
  const { data } = await API.put(p(`lotes/${id}`), payload, auth());
  return data;
};

// DELETE: baja lógica
export const deleteLote = async (id) => {
  const { data } = await API.delete(p(`lotes/${id}`), auth());
  return data;
};
